import { CALYPSO_DARK } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIIcon from 'UIComponents/icon/UIIcon';
import UILink from 'UIComponents/link/UILink';
import { COMPARE_PLANS_LINK } from '../constants/ErrorBoundaryNames';
import { withErrorBoundary } from './ErrorBoundary';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ComparePlansLink = () => {
  const scrollToFeatureTable = () => {
    const element = document.querySelector('#feature-table');
    element.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return /*#__PURE__*/_jsxs("div", {
    className: "m-top-5 flex-column align-center",
    children: [/*#__PURE__*/_jsx(UILink, {
      onClick: scrollToFeatureTable,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricingPage.pages.suiteStarter.compare"
      })
    }), /*#__PURE__*/_jsx(UIIcon, {
      name: "next",
      size: "xxs",
      style: {
        transform: 'rotateZ(90deg)',
        margin: '8px 0'
      },
      color: CALYPSO_DARK,
      className: "m-top-2"
    })]
  });
};
export default withErrorBoundary(ComparePlansLink, {
  boundaryName: COMPARE_PLANS_LINK
});